module.exports = __webpack_public_path__ + "images/adac_small06a64163aadaafafc3c18a996970f2b5.png";